import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { setTheme } from "@/lib/theme";

export const ThemeToggle = ({ className = "" }) => {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));
  const toggle = () => { setTheme(light ? "dark" : "light"); setLight(!light); };
  return (
    <button onClick={toggle} data-testid="theme-toggle" aria-label="Toggle light/dark theme"
      title={light ? "Switch to dark theme" : "Switch to light theme"}
      className={`p-2 border border-white/15 text-gf-muted hover:text-gf-primary hover:border-gf-primary transition-colors ${className}`}>
      {light ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
};
